export const turnKeywordsIntoRegexRespectingWordBoundaries = (keywords: string[]): RegExp => {
    return new RegExp(`(?:\\s|\\(|^)(?:${keywords.join('|')})(?:\\s|:|\\)|=|,|\\.|$)`, 'i');
};
